import { render, staticRenderFns } from "./title-text-cmp.vue?vue&type=template&id=218c8ccc&scoped=true"
import script from "./title-text-cmp.vue?vue&type=script&lang=js"
export * from "./title-text-cmp.vue?vue&type=script&lang=js"
import style0 from "./title-text-cmp.vue?vue&type=style&index=0&id=218c8ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218c8ccc",
  null
  
)

export default component.exports